import api from './api';

export const createRazorpayOrder = async (productId) => {
    const response = await api.post(`/payments/order/${productId}`);
    return response.data;
};

export const verifyRazorpayPayment = async (paymentData) => {
    const response = await api.post('/payments/verify', paymentData);
    return response.data;
};

export const getMyOrders = async () => {
    const response = await api.get('/payments/my-orders');
    return response.data;
};

export const downloadFile = async (orderId, fileName) => {
    const response = await api.get(`/payments/download/${orderId}`, {
        responseType: 'blob',
    });

    // Create a temporary link and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'download');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
